var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVaccinationBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19577_32584)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19577_32584",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "#E9F7EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19577_32584)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.439 94.0761C226.096 96.4193 226.096 100.218 228.439 102.561C230.782 104.905 234.581 104.905 236.924 102.561L228.439 94.0761ZM265.916 73.5704C268.259 71.2272 268.259 67.4282 265.916 65.0851C263.573 62.7419 259.774 62.7419 257.43 65.085L265.916 73.5704ZM265.916 65.0851C263.573 62.7419 259.774 62.7419 257.43 65.085C255.087 67.4281 255.087 71.2271 257.43 73.5703L265.916 65.0851ZM290.665 69.3277L286.422 65.085L290.665 69.3277ZM319.067 49.4111C321.41 47.0679 321.41 43.2689 319.067 40.9258C316.723 38.5826 312.924 38.5826 310.581 40.9258L319.067 49.4111ZM257.43 73.5703C259.773 75.9135 263.572 75.9135 265.916 73.5704C268.259 71.2272 268.259 67.4283 265.916 65.0851L257.43 73.5703ZM261.673 40.3366L265.916 44.5794L265.916 44.5792L261.673 40.3366ZM290.075 20.4194C292.419 18.0763 292.419 14.2773 290.075 11.9341C287.732 9.591 283.933 9.591 281.59 11.9341L290.075 20.4194ZM280.411 2.27038C278.068 -0.0727682 274.269 -0.0727656 271.926 2.27038C269.583 4.61353 269.583 8.41252 271.926 10.7557L280.411 2.27038ZM320.245 59.0748C322.588 61.4179 326.387 61.4179 328.73 59.0748C331.073 56.7316 331.073 52.9326 328.73 50.5895L320.245 59.0748ZM291.254 21.598C288.911 23.9412 288.911 27.7402 291.254 30.0833C293.597 32.4264 297.396 32.4264 299.739 30.0832L291.254 21.598ZM319.656 1.6811L323.898 5.92372L323.899 5.92363L319.656 1.6811ZM329.319 1.6811L333.562 -2.56138L333.562 -2.56143L329.319 1.6811ZM329.319 11.3449L333.562 15.5876L333.562 15.5874L329.319 11.3449ZM300.918 31.2618C298.574 33.6049 298.574 37.4039 300.918 39.7471C303.261 42.0902 307.06 42.0902 309.403 39.747L300.918 31.2618ZM236.924 102.561L265.916 73.5704L257.43 65.085L228.439 94.0761L236.924 102.561ZM257.43 73.5703C267.779 83.9194 284.558 83.9194 294.907 73.5703L286.422 65.085C280.759 70.7478 271.578 70.7478 265.916 65.0851L257.43 73.5703ZM294.907 73.5703L319.067 49.4111L310.581 40.9258L286.422 65.085L294.907 73.5703ZM265.916 65.0851C260.253 59.4222 260.253 50.2413 265.916 44.5794L257.431 36.0938C247.081 46.4423 247.082 63.2213 257.43 73.5703L265.916 65.0851ZM265.916 44.5792L290.075 20.4194L281.59 11.9341L257.43 36.0939L265.916 44.5792ZM271.926 10.7557L320.245 59.0748L328.73 50.5895L280.411 2.27038L271.926 10.7557ZM299.739 30.0832L323.898 5.92372L315.413 -2.56151L291.254 21.598L299.739 30.0832ZM323.899 5.92363C324.224 5.59837 324.751 5.59837 325.077 5.92363L333.562 -2.56143C328.551 -7.57327 320.425 -7.57327 315.413 -2.56143L323.899 5.92363ZM325.077 5.92358C325.402 6.24909 325.402 6.77695 325.077 7.10246L333.562 15.5874C338.574 10.5757 338.574 2.45035 333.562 -2.56138L325.077 5.92358ZM325.077 7.10232L300.918 31.2618L309.403 39.747L333.562 15.5876L325.077 7.10232Z",
    fill: "#F26B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.875 52.5625C280.879 57.5661 283.684 60.3714 288.688 65.375M291.25 47.4375L298.938 55.125",
    stroke: "#F26B8A",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 85,
    cy: 102,
    r: 102,
    fill: "#F26B8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19577_32584",
    x1: -9.9296e-7,
    y1: 31.7143,
    x2: 294.149,
    y2: 141.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccinationBackground);
export default __webpack_public_path__ + "static/media/VaccinationBackground.98b158256b3f1c9a382c28a7247364b5.svg";
export { ForwardRef as ReactComponent };